function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.9004,
  cy: 20.7771,
  r: 20.75,
  fill: "#F35376"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9122 30.7382L20.9005 30.7385L20.9005 30.7384H20.8886C20.753 30.6421 19.0688 29.4409 17.1219 27.7788C15.1613 26.1049 12.9848 24.0055 11.8277 22.1169C11.8275 22.1165 11.8272 22.116 11.8267 22.1152L11.819 22.1022L11.819 22.1022C11.3301 21.2912 11.0713 20.3594 11.0713 19.4061C11.0713 16.5231 13.4176 14.1768 16.3006 14.1768C17.9701 14.1768 19.5202 14.9698 20.4989 16.2873L20.9003 16.8276L21.3017 16.2873C22.2804 14.9699 23.8307 14.1768 25.5 14.1768C28.3829 14.1768 30.7293 16.5231 30.7293 19.4061C30.7293 20.3594 30.4705 21.2912 29.9816 22.1022L29.9814 22.1021L29.9754 22.1128L29.974 22.1151C28.8173 24.0042 26.6401 26.1044 24.6788 27.7788C22.7321 29.4408 21.048 30.6419 20.9122 30.7382Z",
  stroke: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.21,
  cy: 26.973,
  r: 4.9375,
  fill: "#FA5A7D",
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.4599 26.6975C28.5576 26.6975 29.6434 27.4869 29.6434 28.6485V29.501C29.6434 29.5441 29.6074 29.5801 29.5635 29.5801H25.3555C25.3123 29.5801 25.2764 29.5441 25.2764 29.501V28.6485C25.2764 27.4869 26.3621 26.6975 27.4599 26.6975Z",
  stroke: "#FEFEFE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3951 23.9907C28.0966 23.9907 28.6662 24.5604 28.6662 25.2618C28.6662 25.9641 28.0966 26.5329 27.3951 26.5329C26.6929 26.5329 26.124 25.9641 26.124 25.2618C26.124 24.5604 26.6937 23.9907 27.3951 23.9907Z",
  stroke: "#FEFEFE"
});

var SvgVoluntaryLife = function SvgVoluntaryLife(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVoluntaryLife, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/voluntaryLife.a19b57e4.svg";
export { ForwardRef as ReactComponent };